import { checkFlag } from "utils/flags";

export default function(flag, options) {
  if (checkFlag(flag)) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
}
